<template>
    <div class="d-flex flex-column p-2">
        <span class="font-md font-weight-bold text-gray-dk mb-2">Hold on!</span>
        <span class="font-sm text-secondary">That doesn’t seem right.</span>
        <span class="font-sm text-secondary mb-4">Let us work on it and check back again later.</span>
        <span class="font-sm font-weight-bold text-success text-uppercase clickable align-self-end" @click="reload">OK</span>
    </div>
</template>
<script>
export default {
    created() {
        let g4params = {
            'userId': sessionStorage.getItem("userId"),
            'cuid': sessionStorage.getItem("cuid"),
            'ip': sessionStorage.getItem("ip"),
            'user_agent': sessionStorage.getItem("user_agent"),
            'phone': sessionStorage.getItem("phone"),
            'operating_system': sessionStorage.getItem("operating_system"),
            'browser': sessionStorage.getItem("browser"),
            'transaction_type': sessionStorage.getItem("transaction_type"),
            'transaction_reference': sessionStorage.getItem("transaction_reference"),
        }       
        this.triggerG4Event('technical_error',g4params)
    },
    methods: {
        reload() {
            let g4params = {
                'userId': sessionStorage.getItem("userId"),
                'cuid': sessionStorage.getItem("cuid"),
                'ip': sessionStorage.getItem("ip"),
                'user_agent': sessionStorage.getItem("user_agent"),
                'phone': sessionStorage.getItem("phone"),
                'operating_system': sessionStorage.getItem("operating_system"),
                'browser': sessionStorage.getItem("browser"),
                'transaction_type': sessionStorage.getItem("transaction_type"),
                'transaction_reference': sessionStorage.getItem("transaction_reference"),
            }       
            this.triggerG4Event('err_something_went_wrong_click_ok',g4params)
            // sessionStorage.clear();
            window.location.reload();
        },
        triggerG4Event(name, params = {}){
            if (typeof gtag === 'function'){
                gtag("event", name , params)
            } else{
                console.log('GTAG Func Not Defined')
            }
        }
    },
}
</script>